import type { MetricValues } from '../../PageConfigProvider/types/metric';
import { DataType, type SingleDataSet, type TableData } from '../types';
import { getTableDimensionValue, getTableValue } from './table-data';

export const tableToSingleDataSet = (
  table: TableData,
  metric: MetricValues | undefined = table.metrics[0]
): SingleDataSet | undefined => {
  const [dimension, ...otherDimensions] = table.dimensions;
  if (
    dimension === undefined ||
    dimension === 'timeseries' ||
    otherDimensions.length > 0 ||
    metric === undefined ||
    !table.metrics.includes(metric)
  ) {
    return undefined;
  }

  return {
    type: DataType.SINGLE,
    data: Array.from({ length: table.rowCount }, (_, row) => ({
      dim: getTableDimensionValue(table, dimension, row)?.label ?? '',
      value: getTableValue(table, metric, row),
    })),
  };
};
